"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImageWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledImageWrapper = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: ${ui_components_1.baseColors.primaryBlueMed600};
  svg {
    width: 49px;
    height: 49px;
    margin-bottom: 8px;
  }
`;
